// --- 疗养信息 --- //

export default [
  {
    name: 'convalescenceManagement',
    path: '/convalescenceSystem/convalescenceManagement',
    meta: { title: '疗养院管理' },
    component: require('business/convalescenceSystem/convalescenceManagement/list.vue').default
  },
  {
    name: 'convalescenceManagementAdd',
    path: '/convalescenceSystem/convalescenceManagement/add',
    meta: { title: '新增疗养院' },
    component: require('business/convalescenceSystem/convalescenceManagement/add.vue').default
  },
  {
    name: 'convalescenceManagementDetail',
    path: '/convalescenceSystem/convalescenceManagement/detail',
    meta: { title: '疗养院详情' },
    component: require('business/convalescenceSystem/convalescenceManagement/detail.vue').default
  }

]
